var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PLAY_EVENT } from '../enums';
import BasePlayer from './base-player';
var BaseLivePlayer = /** @class */ (function (_super) {
    __extends(BaseLivePlayer, _super);
    function BaseLivePlayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseLivePlayer.prototype.playInner = function (startTime) {
        var videoInfo = this._videoInfos[0];
        this.setPlayEvents(this._curVideoNode, true);
        this._curVideoNode.play(videoInfo);
        this.emit(PLAY_EVENT.VIDEONODE_CHANGE, { videoInfo: videoInfo });
    };
    BaseLivePlayer.prototype.resumeInner = function () {
        var _a;
        if (!this._played) {
            return;
        }
        if ((_a = this._curVideoNode) === null || _a === void 0 ? void 0 : _a.currentVideoInfo) {
            this._curVideoNode.videoplay();
        }
    };
    BaseLivePlayer.prototype.loadInner = function (value, extra) {
        var ret = _super.prototype.loadInner.call(this, value, extra);
        if (!ret) {
            return false;
        }
        this.setCurVideoNode(this._vnList[0]);
        // videoInfos 由 super.loadInner 创建，这里没有了 preloader 手动 load
        this._curVideoNode.load(this._videoInfos[0]);
        return true;
    };
    BaseLivePlayer.prototype.appendAfter = function (videoInfo) {
        // do nothing
    };
    BaseLivePlayer.prototype.checkAccuratePlaytime = function (videoElementTime, videoElementDuration) {
        // do nothing
    };
    BaseLivePlayer.prototype.preparePreloader = function (isFirstLoad, videoInfo) {
        // do nothing
        return null;
    };
    BaseLivePlayer.prototype.getIdleVideoNode = function () {
        return this._vnList[0];
    };
    BaseLivePlayer.prototype.setLevelInner = function (value) {
        return this._curVideoNode.setLevel(value.setLevelMode);
    };
    BaseLivePlayer.prototype.playBlocked = function () {
        _super.prototype.playBlocked.call(this);
        this.pause();
    };
    Object.defineProperty(BaseLivePlayer.prototype, "supportPreload", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLivePlayer.prototype, "supportPlaybackRate", {
        // eslint-disable-next-line @typescript-eslint/class-literal-property-style
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLivePlayer.prototype, "nextVideoInfo", {
        get: function () {
            return this.currentVideoInfo;
        },
        enumerable: false,
        configurable: true
    });
    return BaseLivePlayer;
}(BasePlayer));
export default BaseLivePlayer;
// 禁用直播用不到的一些方法
[
    'seek', 'hasAppended', 'hasPreloaded', 'playNext',
    'appendNext', 'preloadNext', 'clearAllPreload', 'appendAfter',
    'checkPlayNext', 'playNextInner', 'checkAutoPreloadNext', 'clearAllPreloadInner',
].forEach(function (keyName) {
    BaseLivePlayer.prototype[keyName] = function () {
        console.warn("[thumbplayer] ".concat(keyName, "() is not support due to live stream"));
    };
});
